import type {ExportErrorLogsResponse} from '#lit/types/audience_exports.js';

/**
 * Checks if the response was successful but contains errors
 * @returns true if there were errors in the response body
 */

export function responseHasErrors(response: ExportErrorLogsResponse) {
  return response.errors && response.errors.length > 0;
}
/**
 * Checks if the response has usable data
 * @returns true if data exists
 */

export function responseHasData(response: ExportErrorLogsResponse) {
  return response.data && response.data.length > 0;
}
